import { render, staticRenderFns } from "./ahSuggestAccountingItemsSelector.vue?vue&type=template&id=394b2b30&"
import script from "./ahSuggestAccountingItemsSelector.vue?vue&type=script&lang=js&"
export * from "./ahSuggestAccountingItemsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports